/**
 * The AppContext represents all the context in which the user can be logged into SolCentre.
 * For example, is the user currently logged into SolCentre and/or the Commissioning App?
 */
export enum AppContext {
    SolCentre = 'SolCentre',
    ComApp = 'ComApp'
}